import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, Validator, NG_VALIDATORS } from '@angular/forms';

@Directive({
    selector: '[appNumberValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => NumberValidatorDirective),
            multi: true
        }
    ],
    standalone: false
})
export class NumberValidatorDirective implements Validator {

  constructor() { }
  validate(c: AbstractControl): { [key: string]: any; } {
    const currentValue = +c.value;
    return !currentValue ? { required: { message: 'value must be greater than zero' } } : null;
  }
}
